// BiSolidNoEntry
export default {
  a: {},
  c: '<path d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm5 12H7v-4h10v4z"></path>'
};